import { Navigate, Route, Routes } from "react-router-dom";
import { ChatStateProvider } from "@financial-advisory/ui/components/chat";
import {
  ExploreGraphLayout,
  ProductTreesPage,
  RegulationDocumentLayout,
  RegulationsPage,
} from "@financial-advisory/ui/features/decision-tree";
import { NodeHoverProvider } from "@financial-advisory/ui/providers";
import { RequireAuth } from "./RequireAuth";

export const AppRouter = () => (
  <RequireAuth>
    <ChatStateProvider>
      <NodeHoverProvider>
        <Routes>
          <Route>
            <Route index element={<Navigate to="/regulations" replace />} />
          </Route>
          <Route path="regulations">
            <Route path=":regulationId" element={<RegulationDocumentLayout />}>
              <Route index element={<RegulationsPage />} />
            </Route>
            <Route index element={<Navigate to="COBS9" replace />} />
          </Route>
          <Route element={<ExploreGraphLayout />}>
            <Route path="tree" element={<ProductTreesPage />} />
          </Route>
          <Route element={<Navigate to="/" replace />} />
        </Routes>
      </NodeHoverProvider>
    </ChatStateProvider>
  </RequireAuth>
);
